import {
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  REGISTER,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  AUTH_ERROR,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_WITH_CODE,
  LOGOUT,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  REQUEST_RESET_EMAIL,
  REQUEST_RESET_EMAIL_SUCCESS,
  REQUEST_RESET_EMAIL_ERROR,
  CLEAR_AUTH_ERROR,
  OPEN_AUTH_MODAL,
  SET_IS_LOGIN,
  SET_AUTH_FLOW_CONTEXT,
  CLEAR_AUTH_FLOW_CONTEXT,
  GET_FREE_TRIAL_STATUS,
  GET_FREE_TRIAL_STATUS_SUCCESS,
  GET_FREE_TRIAL_STATUS_ERROR,
  REDEEM_FREE_TRIAL,
  REDEEM_FREE_TRIAL_SUCCESS,
  REDEEM_FREE_TRIAL_ERROR,
} from './constants';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  registrationLoading: false,
  user: null,
  userLoading: true,
  userLoaded: false,
  errors: [],
  success: null,
  isAuthModalVisible: false,
  isLogin: false,
  authFlowContext: null,
  freeTrialStatus: null,
  freeTrialLoading: false,
};

function auth(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REGISTER:
    case LOGIN_USER:
    case LOGIN_WITH_CODE:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        registrationLoading: true,
        user: null,
        errors: [],
      };
    case REGISTER_SUCCESS:
    case LOGIN_USER_SUCCESS:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        registrationLoading: false,
        user: payload.user,
        errors: [],
        success: null,
      };
    case AUTH_ERROR:
    case REGISTER_ERROR:
    case LOGIN_USER_ERROR:
    case LOGOUT:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        registrationLoading: false,
        user: null,
        userLoading: false,
        errors: action.errors,
      };
    case LOAD_USER:
      return {
        ...state,
        userLoading: true,
        userLoaded: false,
      };
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: payload,
        userLoading: false,
        userLoaded: true,
        errors: [],
      };
    case LOAD_USER_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        userLoading: false,
        userLoaded: false,
        errors: action.errors,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        errors: action.errors,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        success: payload,
      };
    case REQUEST_RESET_EMAIL_SUCCESS:
      return {
        ...state,
        success: payload,
        errors: [],
      };
    case REQUEST_RESET_EMAIL_ERROR:
      return {
        ...state,
        errors: action.errors,
      };
    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        errors: [],
      };
    case OPEN_AUTH_MODAL:
      return {
        ...state,
        isAuthModalVisible: action.payload,
      };
    case SET_IS_LOGIN:
      return {
        ...state,
        isLogin: action.payload,
      };
    case SET_AUTH_FLOW_CONTEXT:
      return {
        ...state,
        authFlowContext: action.payload,
      };
    case CLEAR_AUTH_FLOW_CONTEXT:
      return {
        ...state,
        authFlowContext: null,
      };
    // Free Trial Cases
    case GET_FREE_TRIAL_STATUS:
    case REDEEM_FREE_TRIAL:
      return {
        ...state,
        freeTrialLoading: true,
      };
    case GET_FREE_TRIAL_STATUS_SUCCESS:
    case REDEEM_FREE_TRIAL_SUCCESS:
      return {
        ...state,
        freeTrialStatus: payload,
        freeTrialLoading: false,
      };
    case GET_FREE_TRIAL_STATUS_ERROR:
    case REDEEM_FREE_TRIAL_ERROR:
      return {
        ...state,
        freeTrialLoading: false,
        errors: payload,
      };
    default:
      return state;
  }
}

export default auth;
